import React, {useEffect} from 'react';
import useAuth from '../../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import ProfIXChatbot from '../../components/chatBot/ProfIXChatbot';

import './login.css';

const Login = () => {
  const navigate = useNavigate();
  const { 
    checkSession, 
    initiateGoogleLogin, 
    initiateMicrosoftLogin, 
    initiateGitHubLogin, 
    isLoading 
  } = useAuth();

  // React.useEffect(() => {
  useEffect(() => {
    const verifySession = async () => {
      const result = await checkSession();
      if (result.authenticated) {
        navigate('/usergate');
      }
    };
    verifySession();
  }, [checkSession, navigate]);

  return (
    <div className="login-container">
      <div className="background-gradient"></div>
      <div className="floating-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
        <div className="shape shape-4"></div>
      </div>

      <div className="login-card">
        <div className="logo-section">
          <img src="/images/prof_ix.png" alt="Logo" className="owner-logo" />
        </div>

        <div className="welcome-section">
          <h1 className="welcome-title">
            ProfiX <span className="brandname">Labs</span>
          </h1>
          <h3 className="welcome-title2">AI-Powered Visual STEM Learning</h3>
          <p className="welcome-subtitle">Sign in to access your training dashboard</p>
        </div>

        <div className="login-button-wrapper">
          {isLoading ? (
            <div className="loading-spinner">
              <div className="spinner"></div>
              <p>Signing you in...</p>
            </div>
          ) : (
            <div className="oauth-buttons">
              {/* Google Login */}
              <button onClick={initiateGoogleLogin} className="oauth-button google-button">
                <img 
                  src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" 
                  alt="Google"
                  className="oauth-icon"
                />
                <span>Continue with Google</span>
              </button>

              {/* Microsoft Login */}
              <button onClick={initiateMicrosoftLogin} className="oauth-button microsoft-button">
                <svg className="oauth-icon" viewBox="0 0 21 21" fill="none">
                  <rect x="1" y="1" width="9" height="9" fill="#f25022"/>
                  <rect x="1" y="11" width="9" height="9" fill="#00a4ef"/>
                  <rect x="11" y="1" width="9" height="9" fill="#7fba00"/>
                  <rect x="11" y="11" width="9" height="9" fill="#ffb900"/>
                </svg>
                <span>Continue with Microsoft</span>
              </button>

              {/* GitHub Login */}
              <button onClick={initiateGitHubLogin} className="oauth-button github-button">
                <svg className="oauth-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                </svg>
                <span>Continue with GitHub</span>
              </button>
            </div>
          )}
        </div>

        <div className="features-section">
          <div className="feature-item">
            <span className="feature-icon">🔒</span>
            <span className="feature-text">Secure & Private</span>
          </div>
          <div className="feature-item">
            <span className="feature-icon">💬</span>
            <span className="feature-text">Real-time Messaging</span>
          </div>
          <div className="feature-item">
            <span className="feature-icon">📊</span>
            <span className="feature-text">Progress Tracking</span>
          </div>
        </div>
        
        <div className="login-footer">
          <p>By signing in, you agree to our Terms of Service and Privacy Policy</p>
        </div>
      </div>

      <div style={{position: 'absolute', bottom: '140px', right:'100px'}}>
        <ProfIXChatbot category="gateway" />
      </div>

    </div>
  );
};

export default Login;